import { render, staticRenderFns } from "./employee-role-page.html?vue&type=template&id=1613d483&"
import script from "./employee-role-page.ts?vue&type=script&lang=ts&"
export * from "./employee-role-page.ts?vue&type=script&lang=ts&"
import style0 from "./employee-role-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports